<template>
    <div class="ai-msg-logic">
        <div
            v-for="(logic, index) in data"
            :key="index"
            class="ai-msg-logic-line"
        >
            <img src="@/theme/images/icons/icon_check_round_outline.svg">
            <div>
                <span class="logic-title">{{ logic.title }}</span>
                <span class="logic-content">{{ logic.content }}</span>
            </div>
            <div
                v-if="logic.link"
                class="logic-link"
                @click="openLink(logic.link.link)"
            >
                <img src="@/theme/images/icons/icon_link_outline.svg">
                <div>{{ logic.link.text }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MsgChatRespondLogic',
    props: [ 'data' ],
    methods: {
        openLink (link) {
            window.open(link);
        }
    }
};
</script>
<style lang="scss">
.ai-msg-logic {
    box-sizing: border-box;
    width: 100%;
    padding: 8px 15px;
    margin: 4px 0;
    background: var(--msg-ai-logic-bg);
    border-radius: 4px;
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
}

.ai-msg-logic-line {
    height: 30px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;

    >img {
        width: 20px;
        margin-right: 4px;
    }

    .logic-title {
        font-size: 14px;
        color: #505050;
        line-height: 20px;
    }

    .logic-content {
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
        font-weight: 500;
        color: #000000;
        line-height: 20px;
    }

    .logic-link {
        background: var(--msg-ai-logic-link-bg);
        border-radius: 2px;
        height: 24px;
        margin-left: 8px;
        padding: 0 8px 0 6px;
        cursor: pointer;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;

        img {
            width: 12px;
        }

        div {
            font-size: 12px;
            color: #F55212;
            line-height: 18px;
        }
    }

}
</style>
